import { BoardSize } from '@pindd/types'

export const twoSixMmBoards: BoardSize[] = [
  {
    id: '2.6mm-small',
    name: '小号 25×25',
    width: 25,
    height: 25,
    beadSize: '2.6mm',
    physicalWidth: 65,
    physicalHeight: 65,
  },
  {
    id: '2.6mm-medium',
    name: '中号 52×52',
    width: 52,
    height: 52,
    beadSize: '2.6mm',
    physicalWidth: 135,
    physicalHeight: 135,
  },
  {
    id: '2.6mm-large',
    name: '大号 104×104',
    width: 104,
    height: 104,
    beadSize: '2.6mm',
    physicalWidth: 270,
    physicalHeight: 270,
  },
]
